<template>
  <div class="pb-4 text-subtitle-1">
    {{ text }}
  </div>
</template>
<script>
export default {
  name: "Subtitle",
  props: {
    text: null
  }
}
</script>
